import api from "services/api";
import type { FornecedorFinanceiroApi } from "../types/contas-pagar.types";

export async function listarFornecedoresFinanceiro(): Promise<{
  data: FornecedorFinanceiroApi[] | null;
  status: number;
}> {
  const res = await api.get<FornecedorFinanceiroApi[]>(
    "/loja/financeiro/fornecedores",
  );
  return { data: res.data ?? null, status: res.status };
}

export async function criarFornecedorFinanceiro(payload: {
  nome: string;
  nomeFantasia?: string | null;
  documento?: string | null;
  email?: string | null;
}): Promise<{ data: FornecedorFinanceiroApi | null; status: number }> {
  try {
    const res = await api.post<FornecedorFinanceiroApi>(
      "/loja/financeiro/fornecedores",
      payload,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    const ax = e as { response?: { data?: { error?: string }; status?: number } };
    const msg = ax.response?.data?.error;
    if (msg) throw new Error(msg);
    throw e;
  }
}
